import apiService from './apiServices';
import axios from 'axios'; // Keep axios for direct Cloudinary upload (3rd party)

// Get secure upload signature from backend
const getUploadSignature = async () => {
    const response = await apiService.get('/media/sign-upload');
    return response.data;
};

// Delete image from Cloudinary
const deleteImage = async (publicId) => {
    if (!publicId) return;
    try {
        const response = await apiService.delete('/media', { data: { publicId } });
        return response.data;
    } catch (error) {
        console.error("Error deleting image:", error);
        throw error;
    }
};

// Upload to Cloudinary directly
const uploadToCloudinary = async (file, onProgress) => {
    // 1. Get Signature
    const { signature, timestamp, cloudName, apiKey, folder, uploadPreset } = await getUploadSignature();

    // 2. Prepare Form Data
    const formData = new FormData();
    formData.append('file', file);
    formData.append('api_key', apiKey);
    formData.append('timestamp', timestamp);
    formData.append('signature', signature);
    formData.append('folder', folder);

    if (uploadPreset) {
        formData.append('upload_preset', uploadPreset);
    }

    // 3. Upload
    const response = await axios.post(
        `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
        formData,
        {
            onUploadProgress: (progressEvent) => {
                if (onProgress) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    onProgress(percentCompleted);
                }
            }
        }
    );

    return response.data;
};

const mediaService = {
    getUploadSignature,
    deleteImage,
    uploadToCloudinary
};

export default mediaService;
